var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("i", {
    class: [_vm.icon[0], "fa-" + _vm.icon[1]]
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };